import React from "react";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import { Box, Grid, IconButton, Stack } from "@mui/material";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import { DatePicker } from "@mui/x-date-pickers";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";

const getOrdinal = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const AddInstallments = ({ installments, setInstallment }) => {
  const handleAddAnotherInstallment = () => {
    let tempArray = [...installments];
    tempArray.push({
      type: "",
      fee: 0,
      date: null,
      installmentNo: 1,
    });
    setInstallment(tempArray);
  };

  const handleDelete = (index) => {
    let tempArray = [...installments];
    tempArray.splice(index, 1);
    setInstallment(tempArray);
  };

  return (
    <Box mb={2}>
      {installments.map((val, index) => {
        return (
          <Grid container spacing={2} key={index} mb={1}>
            <Grid item xs={12} sm={6} md={4}>
              <Label
                labelText={`${getOrdinal(index + 1)} Installment`}
                htmlFor={`class_fee_installments_${index}`}
                required
              />
              <TextInput
                id={`class_fee_installments_${index}`}
                required
                placeholder={"Enter installment"}
                styleProps={globalStyle.textField}
                type={"number"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Label
                labelText={`${getOrdinal(index + 1)} Installment date`}
                htmlFor={`class_fee_installments_${index}`}
                required
              />
              <DatePicker
                sx={{
                  "&.MuiTextField-root": { width: "100% !important" },
                  ...globalStyle.textField,
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              display={"flex"}
              alignItems={"flex-end"}
            >
              {index !== 0 ? (
                <IconButton
                  onClick={() => handleDelete(index)}
                  sx={{ ml: "1rem" }}
                >
                  <DeleteForeverOutlinedIcon
                    htmlColor="red"
                    sx={{ fontSize: "2rem" }}
                  />
                </IconButton>
              ) : (
                <Stack
                  direction={"column"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Label
                    labelText="Add Another"
                    labelProps={{ color: "#08AD36" }}
                  />
                  <IconButton onClick={handleAddAnotherInstallment}>
                    <AddBoxOutlinedIcon sx={{ color: "#08AD36" }} />
                  </IconButton>
                </Stack>
              )}
            </Grid>
          </Grid>
        );
      })}
    </Box>
  );
};

export default AddInstallments;
